
import * as React from "react";
import { navigate } from "gatsby";
import { auth, db } from '../../../firebase-info';
import { onAuthStateChanged } from "firebase/auth";
import {
    doc,
    onSnapshot,
} from "firebase/firestore";
import { AuthContext } from "../contexts/contexts.js";
import { ROLE_ADMIN, ROLE_PRESIDENT } from "../../utils/constants.jsx";
import { getDataOf } from "../../utils/firestore-utils.jsx";
import { neighbourHasRoles } from "../../utils/functions.js";

const AuthContextComponent = ({ children, location }) => {
    const [user, setUser] = React.useState(null);
    const [userData, setUserData] = React.useState(null);
    const [userRef, setUserRef] = React.useState(null);
    const [loading, setLoading] = React.useState(true)

    const allowedUnauthPathnameRegexs = [
        /(\/)/,     // '/'
        /(\/register\/[a-zA-Z0-9]+)/,   //'/register/',
    ];

    const suscribeAuthChanges = () => { onAuthStateChanged(auth, async (loggedUser) => {
          if (!loggedUser) {
            setUserRef(null)
            setUserData(null);
            setLoading(false);
            
          } else {
              setUser(loggedUser);

              const uRef = doc(db, "users", loggedUser.uid);
              
              setUserRef(uRef)
              subscribeUserData(uRef);
          }
    })};

    // This listener updates if active neighbour or neighbour array changes
    const subscribeUserData = (uRef) => {
        return onSnapshot(doc(db, "users", uRef.id), (changes) => {
            const data = changes.data()
            setUserData({...userData, ...data});
            setLoading(false);
        });
    }

    const allowedPresidentPathnameRegex = [
        /(\/admin\/announce\/create)/,
        /(\/admin\/announce\/edit\/[a-zA-Z0-9]+)/,
        /(\/admin\/meeting\/create)/,
        /(\/admin\/meeting\/edit\/[a-zA-Z0-9]+)/,
        /(\/admin\/community\/select-create)/,
    ]

    const checkAdminPath = async() => {
        const isAdministationPath = /(\/admin.*)/.test(location?.pathname);

        if(userData && isAdministationPath){
            let isAdmin, isPresident;
            if(userData.activeNeighbour === null){
                isAdmin = userData.role === ROLE_ADMIN;
                isPresident = false;
            }
            else{
                const neighbourData = await getDataOf(userData.activeNeighbour);
    
                isAdmin = neighbourHasRoles(neighbourData, [ROLE_ADMIN])
                isPresident = neighbourHasRoles(neighbourData, [ROLE_PRESIDENT])
            }

            if(!isAdmin){
                if(!isPresident){
                    // Ni AF ni JG, redirigir a index
                    navigate("/");
                    return;
                }

                if(allowedPresidentPathnameRegex.every((regex) => !regex.test(location?.pathname))){
                    // La location actual no coincide con ningun path autorizado, redigir a index
                    navigate("/");
                    return;
                }
            }
            // Si llega hasta aquí, autorizado
        }
    };

    const checkPath = () => {
        if (!loading && !user) {
            if(allowedUnauthPathnameRegexs.some((regex) => regex.test(location?.pathname))) return;
    
            navigate('/');

            return false;
        }

        return true;
    }

  const authContextValue = React.useMemo(() => ({ user, userData, userRef, loading }), [user, userData, userRef, loading]);

    React.useEffect(() => {
        suscribeAuthChanges();
    }, []);

    React.useEffect(() => {
        if (checkPath()) {
            checkAdminPath()
        }
    }, [location?.pathname, userData, loading])

  return (
    <AuthContext.Provider value={authContextValue}>
        {children}
    </AuthContext.Provider>
  )
}

export default AuthContextComponent;